export const NEWBUILDING_KPN_CHAT = 'newbuilding_kpn_chats_jk_desktop';
